<template>
  <div class="footer_box">
    <div class="footer_content">
      <div class="footer_left">
        <img loading="lazy" :src="logo" alt="">
        <div class="tel">{{ language ? '电话' :'Tel' }}：0371-63969330</div>
        <div class="tel">{{ language ? '传真' :'Fax' }}：0371-65521780</div>
      </div>
      <div class="footer_middle">
        <p class="footer_middle_1" v-for="(item,index) in navData" :key="index">
          <span
            @click="gourl(n.path,index,i)"
            :class="['text',{text_first:i === 0,text_seleted:active===index&&sumActive ===i}]"
            v-for="(n,i) in item" :key="n.name">
            {{ n.name }}
        </span>
        </p>
      </div>
      <div class="qrCode_view">
        <img
          class="qrCode"
          src="https://huahua-cdn.17huahua.cn/huala-management-front/166907959001351.png"
          alt=""
        />
        <div class="qrCode_text">{{ language ? '扫描二维码':'scan QR code' }}</div>

      </div>
    </div>
    <div @click="openClick" class="record">New Power All Rights Reserved.Power By Obvious 豫ICP备2020029017号</div>
  </div>
</template>
<script>
const englishData = [
  [
    {
      name: "About BCCY",
    },
    {
      name: "Company introduction",
      path: '/english/about/0'
    },
    {
      name: "Corporate culture",
      path: '/english/about/1'
    },
    {
      name: "Technical capability",
      path: '/english/about/2'
    },

  ],
  [
    {
      name: "Solution",
    },
    {
      name: "Biogas power generation",
      path: '/english/solution/0'
    },
    {
      name: "Mobile heating",
      path: '/english/solution/1'
    },
    {
      name: "Carbon emission reduction project development and trading",
      path: '/english/solution/2'
    },
    {
      name: "Solid waste disposal",
      path: '/english/solution/3'
    },
    {
      name: "Electricity sale service",
      path: '/english/solution/4'
    },

  ],
];
const navData = [
  [
    {
      name: "关于百川",
    },
    {
      name: "公司介绍",
      path: '/about/0'
    },
    {
      name: "企业文化",
      path: '/about/1'
    },
    {
      name: "技术能力",
      path: '/about/2'
    },

  ],
  [
    {
      name: "解决方案",
    },
    {
      name: "沼气发电",
      path: '/solution/0'
    },
    {
      name: "移动储能",
      path: '/solution/1'
    },
    {
      name: "碳减排项目开发与交易",
      path: '/solution/2'
    },
    {
      name: "固废处置",
      path: '/solution/3'
    },
    {
      name: "售电服务",
      path: '/solution/4'
    },

  ],
  [
    {
      name: "投资者关系",
      path: '/investor'
    },
    {
      name: "股票行情",
      path: '/investor'
    },
    {
      name: "公司公告",
      path: '/investor'
    }

  ],
  [
    {
      name: "新闻资讯",
    },
    {
      name: "公司新闻",
      path: '/news/0'
    },
    {
      name: "媒体动态",
      path: '/news/1'
    },

  ],
  [
    {
      name: "加入我们",
    },
    {
      name: "人才理念",
      path: '/joinUs/0'
    },
    {
      name: "招聘信息",
      path: '/joinUs/1'
    },

  ],

];
import Logo from "@/assets/header/logo@2x.png";
import English from "@/assets/header/english.png";
export default {
  data() {
    return {
      navData: [],
      isphone: false,
      active: undefined,
      sumActive: 0,
      language: true,
      logo:Logo
    };
  },
  watch: {
    $route(to, from) {

      this.activenum();
    },
  },
  created() {
    this.activenum()
  },
  mounted() {},
  methods: {
    activenum() {
      const path = this.$route.path;
      if (this.$route.meta.english) {
        this.language = false;
      } else {
        this.language = true;
      }
      this.navData = this.language ? navData : englishData;
      this.logo = this.language ? Logo : English;
      this.navData.forEach((item,index) =>
        item.forEach((n, i) => {
          if (n.path === path) {
            this.active = index;
            this.sumActive = i;
            return;
          }
        } )
      )
    },
    gourl(url,index,i) {
      this.$router.push({
        path: url
      });
      this.active = index;
      this.sumActive = i;
    },
    openClick() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    }
  }
};
</script>
<style scoped>
.footer_box {
  width: 100%;
  height: 480px;
  background: #f6f7fb;
  overflow: hidden;
}
@media screen and (max-width:1200px) {
  .footer_box {
  width: 1200px;
}
}
.footer_content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 60px 0 48px;
  border-bottom: 1px solid rgba(214,215,219,0.5);
}

.footer_left{
  width: 168px;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
}
.footer_left img {
  width: 138px;
  height: 32px;
}

.footer_middle{
  flex: 1;
  padding-left: 100px;
  padding-right: 175px;
  display: flex;
  justify-content: space-between;

}
.footer_middle_1{
  display: flex;
  flex-direction: column;
  /* justify-content: start; */
}
.qrCode_view {
  width: 95px;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.footer_middle{
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #50525f;
}

.text{
  margin-top: 20px;
  cursor: pointer;
}
.text:hover{
  color: #00A9BA;
}
.text_first{
  margin-top: 0;
  font-size: 14px;
}
.text_seleted{
  color:#00A9BA;
}
.qrCode {
  width: 95px;
  height: 95px;
}
.qrCode_text {
  font-size: 14px;
  color: #8f8f8f;
  margin-top: 7px;
}
.record{
  width: 100%;
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #595c6d;
  line-height: 17px;
  margin-top: 48px;
  cursor: pointer;
}
.tel{
  font-size: 14px;
  color: #8f8f8f;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/component/home/bottom.vue